import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Fitnes",
  "description": "",
  "published": "2007-09-03T00:00:00.000Z",
  "redirect_from": ["/blog/fitnes/swizec/159"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Po enem tednu se mi je danes konÄno spet uspelo spraviti na fitnes in se malo pretegnit, kar je bilo zaradi zmešanega delovnika zadnje Äase nemogoÄe. Odkar sem zaÄel fitnesirati je to najdaljše obdobje tišine in obÄutek je bil kar Äuden. Po svoje si ves švoh in nesposoben, hkrati pa se nekako nisem tako utrudil kot ponavadi. MogoÄe sem pa le lenaril v strahu pred poškodbami iz švohnote.`}</p>
    <p>{`Mi je pa vseeno se skoraj uspelo poškodovati, ko sen delal benÄpres. Štanga se na levi strani nekako ni uspela zataknit, ko sem se odloÄi, da je konec, roke pa sem vseeno sprostil. Na sreÄo je štanga tako dolga, da je prej zadela ob tla kot pokvarila moj obraz. ÄŒe od dvigovanja mrtve teÅ¾e ne bi bil tako zmahan, bi me dogodek verjetno globoko pretresel.`}</p>
    <p>{`Sem omenil zmešan delovnik kajne? Ukvarjamo se z nekim projektom, ki ga je treba kaj hitro dokonÄati, Äeprav smo ga v skrb dobili šele pred kratkim, kar je zahtevalo v povpreÄju 12 ur dela na dan. ÄŒe bi bil redno zaposlen to še niti ne bi bilo tako slabo ampak vraga to je v osnovi samo študentsko delo!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      